import * as z from "zod";

export const RecognizeProfileDetails = z.object({
  profileId: z.string(),
  email: z.string().nullable(),
  mercana: z.record(z.string(), z.json()).nullable(),
  identityConfidence: z.number().nullable(),
  identityConfidenceBand: z.string().nullable(),
});
export type RecognizeProfileDetails = z.infer<typeof RecognizeProfileDetails>;
